import mutations from '@/store/settings/mutations';
const Settings = {
    state: {
        isFormApiLoading: false,
        setFormApiError: false,
        apiErrorCode: null
    },
    mutations
};
export default Settings;
